// eslint-disable-next-line
import { UserLayout } from '@/layouts'
/**
 * Note: 路由配置项
 *
 * hidden: true                     // 当设置 true 的时候该路由不会再侧边栏出现 如401，login等页面，或者如一些编辑页面/edit/1
 * alwaysShow: true                 // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式
 *                                  // 只有一个时，会将那个子路由当做根路由显示在侧边栏
 *                                  // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                  // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * redirect: noRedirect             // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'               // 设定路由的名字，一定要填写不然使用<keep-alive>时会出现各种问题,此名称与页面name一致
 * meta : {
    noCache: true                   // 如果设置为true，则不会被 <keep-alive> 缓存(默认 false)
    title: 'title'                  // 设置该路由在侧边栏和面包屑中展示的名字
    icon: 'svg-name'                // 设置该路由的图标
  }
 */
export const indexRouterMap = [
  {
    path: '/index',
    name: 'Index',
    component: 'Index',
    meta: { title: '首页', noCache: false, hidden: true, icon: 'dashboard', hiddenHeaderContent: true }
  },
  // ERP 业务菜单按领域直接展示为一级目录，不再额外包裹“ERP管理”。
  // 动态路由会扁平挂到 BasicLayout 下，须保留绝对 path。
  {
    path: '/erp/customer-management',
    name: 'ErpCustomerManagement',
    component: 'RouteView',
    redirect: '/erp/customer',
    alwaysShow: true,
    meta: { title: '客户管理', noCache: false, icon: 'team' },
    children: [
      {
        path: '/erp/customer',
        name: 'ErpCustomer',
        component: 'ErpCustomer',
        permissions: ['erp:customer:list'],
        meta: { title: '客户档案', noCache: false, icon: 'profile' }
      },
      {
        path: '/erp/crm/lead',
        name: 'ErpCrmLead',
        component: 'ErpCrmLead',
        permissions: ['erp:crm:lead:list'],
        hidden: true,
        meta: { title: '线索单', noCache: false, icon: 'flag' }
      },
      {
        path: '/erp/crm/follow-up',
        name: 'ErpCrmFollowUp',
        component: 'ErpCrmFollowUp',
        permissions: ['erp:crm:follow-up:list'],
        hidden: true,
        meta: { title: '跟进记录单', noCache: false, icon: 'message' }
      },
      {
        path: '/erp/crm/reminder',
        name: 'ErpCrmReminder',
        component: 'ErpCrmReminder',
        permissions: ['erp:crm:reminder:list'],
        hidden: true,
        meta: { title: '跟进待办', noCache: true, icon: 'schedule' }
      },
      {
        path: '/erp/crm/public-pool',
        name: 'ErpCrmPublicPool',
        component: 'ErpCrmPublicPool',
        permissions: ['erp:crm:pool:list'],
        hidden: true,
        meta: { title: '公海池客户', noCache: false, icon: 'global' }
      },
      {
        path: '/erp/crm/pool-config',
        name: 'ErpCrmPoolConfig',
        component: 'ErpCrmPoolConfig',
        permissions: ['erp:crm:pool:config:view'],
        hidden: true,
        meta: { title: '公海配置', noCache: false, icon: 'setting' }
      }
    ]
  },
  {
    path: '/erp/product-management',
    name: 'ErpProductManagement',
    component: 'RouteView',
    redirect: '/erp/product',
    alwaysShow: true,
    meta: { title: '商品管理', noCache: false, icon: 'shopping' },
    children: [
      {
        path: '/erp/product',
        name: 'ErpProduct',
        component: 'ErpProduct',
        permissions: ['erp:product:list'],
        meta: { title: '商品档案', noCache: false, icon: 'shopping' }
      },
      {
        path: '/erp/price-system',
        name: 'ErpPriceSystem',
        component: 'ErpPriceSystem',
        permissions: ['erp:price-system:list'],
        hidden: true,
        meta: { title: '价格体系', noCache: false, icon: 'account-book' }
      },
      {
        path: '/erp/guide-price',
        name: 'ErpGuidePrice',
        component: 'ErpGuidePrice',
        permissions: ['erp:guide-price:list'],
        hidden: true,
        meta: { title: '销售指导价', noCache: false, icon: 'dollar' }
      }
    ]
  },
  {
    path: '/erp/purchase-management',
    name: 'ErpPurchaseManagement',
    component: 'RouteView',
    redirect: '/erp/purchase-order',
    alwaysShow: true,
    meta: { title: '采购管理', noCache: false, icon: 'shopping-cart' },
    children: [
      {
        path: '/erp/supplier',
        name: 'ErpSupplier',
        component: 'ErpSupplier',
        permissions: ['erp:supplier:list'],
        meta: { title: '供应商档案', noCache: false, icon: 'team' }
      },
      {
        path: '/erp/purchase-order',
        name: 'ErpPurchaseOrder',
        component: 'ErpPurchaseOrder',
        permissions: ['erp:purchase-order:list'],
        meta: { title: '采购订单', noCache: false, icon: 'profile' }
      },
      {
        path: '/erp/purchase-inbound',
        name: 'ErpPurchaseInbound',
        component: 'ErpPurchaseInbound',
        permissions: ['erp:purchase-inbound:list'],
        meta: { title: '采购入库单', noCache: false, icon: 'import' }
      }
    ]
  },
  {
    path: '/erp/sales-management',
    name: 'ErpSalesManagement',
    component: 'RouteView',
    redirect: '/erp/sales-order',
    alwaysShow: true,
    meta: { title: '销售管理', noCache: false, icon: 'profile' },
    children: [
      {
        path: '/erp/sales-order',
        name: 'ErpSalesOrder',
        component: 'ErpSalesOrder',
        permissions: ['erp:sales-order:list'],
        meta: { title: '销售订单', noCache: false, icon: 'profile' }
      },
      {
        path: '/erp/sales-outbound',
        name: 'ErpSalesOutbound',
        component: 'ErpSalesOutbound',
        permissions: ['erp:sales-outbound:list'],
        meta: { title: '销售出库单', noCache: false, icon: 'export' }
      },
      {
        path: '/erp/sales-allowance',
        name: 'ErpSalesAllowanceV2',
        component: 'ErpSalesAllowanceV2',
        permissions: ['erp:sales-allowance:list'],
        meta: { title: '销售折让单', noCache: true, icon: 'money-collect' }
      }
    ]
  },
  {
    path: '/erp/finance-management',
    name: 'ErpFinanceManagement',
    component: 'RouteView',
    redirect: '/erp/finance/sales-reconciliation',
    alwaysShow: true,
    meta: { title: '财务管理', noCache: false, icon: 'account-book' },
    children: [
      {
        path: '/erp/finance/sales-reconciliation',
        name: 'ErpFinanceReconciliation',
        component: 'ErpFinanceReconciliation',
        permissions: ['erp:finance:sales-reconciliation:list'],
        meta: { title: '销售对账单', noCache: false, icon: 'audit' }
      },
      {
        path: '/erp/finance/receipt',
        name: 'ErpFinanceReceipt',
        component: 'ErpFinanceReceipt',
        permissions: ['erp:finance:receipt:list'],
        meta: { title: '收款单', noCache: false, icon: 'pay-circle' }
      },
      {
        path: '/erp/finance/payment',
        name: 'ErpFinancePayment',
        component: 'ErpFinancePayment',
        permissions: ['erp:finance:payment:list'],
        meta: { title: '付款单', noCache: false, icon: 'wallet' }
      },
      {
        path: '/erp/finance/payment-flow',
        name: 'ErpFinancePaymentFlow',
        component: 'ErpFinancePaymentFlow',
        permissions: ['erp:finance:payment-flow:list'],
        meta: { title: '支付流水', noCache: false, icon: 'transaction' }
      }
    ]
  },
  {
    path: '/erp/delivery-management',
    name: 'ErpDeliveryManagement',
    component: 'RouteView',
    redirect: '/erp/delivery/wave-pick',
    alwaysShow: true,
    meta: { title: '配送管理', noCache: false, icon: 'car' },
    children: [
      {
        path: '/erp/delivery/wave-pick',
        name: 'ErpDeliveryWavePick',
        component: 'ErpDeliveryWavePick',
        permissions: ['erp:delivery:wave-pick:list'],
        meta: { title: '波次拣货单', noCache: true, icon: 'shopping-cart' }
      },
      {
        path: '/erp/delivery/task',
        name: 'ErpDeliveryTask',
        component: 'ErpDeliveryTask',
        permissions: ['erp:delivery:task:list'],
        meta: { title: '待配送任务', noCache: true, icon: 'schedule' }
      },
      {
        path: '/erp/delivery/route',
        name: 'ErpDeliveryRoute',
        component: 'ErpDeliveryRoute',
        permissions: ['erp:delivery:route:list'],
        meta: { title: '线路派车单', noCache: true, icon: 'car' }
      },
      {
        path: '/erp/delivery/sign',
        name: 'ErpDeliverySign',
        component: 'ErpDeliverySign',
        permissions: ['erp:delivery:sign:list'],
        meta: { title: '配送签收', noCache: true, icon: 'check-circle' }
      }
    ]
  },
  {
    path: '/erp/inventory-management',
    name: 'ErpInventoryManagement',
    component: 'RouteView',
    redirect: '/erp/warehouse',
    alwaysShow: true,
    meta: { title: '库存管理', noCache: false, icon: 'database' },
    children: [
      {
        path: '/erp/warehouse',
        name: 'ErpWarehouse',
        component: 'ErpWarehouse',
        permissions: ['erp:warehouse:list'],
        meta: { title: '仓库档案', noCache: false, icon: 'home' }
      },
      {
        path: '/erp/stock-ledger',
        name: 'ErpStockLedger',
        component: 'ErpStockLedger',
        permissions: ['erp:stock-ledger:list'],
        meta: { title: '库存台账', noCache: false, icon: 'database' }
      },
      {
        path: '/erp/stock-flow',
        name: 'ErpStockFlow',
        component: 'ErpStockFlow',
        permissions: ['erp:stock-flow:list'],
        meta: { title: '库存流水', noCache: false, icon: 'unordered-list' }
      },
      {
        path: '/erp/other-stock-in',
        name: 'ErpOtherStockIn',
        component: 'ErpOtherStockIn',
        permissions: ['erp:stock:other-in:list'],
        meta: { title: '其他入库单', noCache: false, icon: 'import' }
      },
      {
        path: '/erp/other-stock-out',
        name: 'ErpOtherStockOut',
        component: 'ErpOtherStockOut',
        permissions: ['erp:stock:other-out:list'],
        meta: { title: '其他出库单', noCache: false, icon: 'export' }
      },
      {
        path: '/erp/stocktake',
        name: 'ErpStocktake',
        component: 'ErpStocktake',
        permissions: ['erp:stock:stocktake:list'],
        meta: { title: '库存盘点', noCache: false, icon: 'audit' }
      },
      {
        path: '/erp/stock-profit',
        name: 'ErpStockProfit',
        component: 'ErpStockProfit',
        permissions: ['erp:stock:profit:list'],
        meta: { title: '盘盈单', noCache: false, icon: 'rise' }
      },
      {
        path: '/erp/stock-loss',
        name: 'ErpStockLoss',
        component: 'ErpStockLoss',
        permissions: ['erp:stock:loss:list'],
        meta: { title: '盘亏单', noCache: false, icon: 'fall' }
      }
    ]
  },
  {
    path: '/erp/opening-management',
    name: 'ErpOpeningManagement',
    component: 'RouteView',
    redirect: '/erp/stock-opening',
    alwaysShow: true,
    meta: { title: '期初管理', noCache: false, icon: 'inbox' },
    children: [
      {
        path: '/erp/stock-opening',
        name: 'ErpStockOpening',
        component: 'ErpStockOpening',
        permissions: ['erp:stock-opening:list'],
        meta: { title: '库存期初', noCache: false, icon: 'inbox' }
      }
    ]
  },
  {
    path: '/erp/report-management',
    name: 'ErpReportManagement',
    component: 'RouteView',
    redirect: '/erp/report/customer-sales-detail',
    alwaysShow: true,
    meta: { title: '报表', noCache: false, icon: 'bar-chart' },
    children: [
      {
        path: '/erp/report/customer-sales-detail',
        name: 'ErpCustomerSalesDetailReport',
        component: 'ErpCustomerSalesDetailReport',
        permissions: ['erp:report:customer-sales-detail:list'],
        meta: { title: '客商销售明细表', noCache: false, icon: 'file-text' }
      }
    ]
  },
  {
    path: '/erp/basic-setting-management',
    name: 'ErpBasicSettingManagement',
    component: 'RouteView',
    redirect: '/system/basic-settings',
    alwaysShow: true,
    meta: { title: '基础设置', noCache: false, icon: 'setting' },
    children: [
      {
        path: '/system/basic-settings',
        name: 'ErpBasicSettings',
        component: 'ErpBasicSettings',
        permissions: ['erp:basic-settings:list'],
        meta: { title: '业务基础设置', noCache: false, icon: 'setting' }
      },
      {
        path: '/erp/area',
        name: 'ErpArea',
        component: 'ErpArea',
        permissions: ['erp:area:list'],
        meta: { title: '区域', noCache: false, icon: 'environment' }
      },
      {
        path: '/erp/delivery-line',
        name: 'ErpDeliveryLine',
        component: 'ErpDeliveryLine',
        permissions: ['erp:basic-settings:list'],
        meta: { title: '配送线路', noCache: false, icon: 'branches' }
      },
      {
        path: '/erp/operation-rule',
        name: 'ErpOperationRule',
        component: 'ErpOperationRule',
        permissions: ['erp:operation-rule:list'],
        meta: { title: '运营规则', noCache: false, icon: 'schedule' }
      },
      {
        path: '/erp/freight-rule',
        name: 'ErpFreightRule',
        component: 'ErpFreightRule',
        permissions: ['erp:freight-rule:list'],
        meta: { title: '运费规则', noCache: false, icon: 'pay-circle' }
      },
      {
        path: '/erp/open-api-monitor',
        name: 'ErpOpenApiMonitor',
        component: 'ErpOpenApiMonitor',
        permissions: ['erp:open-api-monitor:list'],
        meta: { title: '华住接口排查', noCache: false, icon: 'api' }
      }
    ]
  },
  {
    path: '/account/center',
    name: 'Center',
    component: 'AccountCenter',
    meta: { title: '个人中心', noCache: true },
    hidden: true
  },
  {
    path: '/sms/zrw-info/index/:id(\\d+)',
    name: 'ZrInfo',
    component: 'zrIndex',
    meta: { title: '短信设置', noCache: true, hiddenHeaderContent: true },
    hidden: true
  },
  {
    path: '/account/settings',
    name: 'Settings',
    component: 'AccountSettings',
    meta: { title: '个人设置', noCache: true },
    hidden: true
  },
  {
    path: '/monitor/job/log',
    name: 'JobLog',
    component: 'JobLog',
    meta: { title: '调度日志', noCache: true },
    permissions: ['monitor:job:list'],
    hidden: true
  },
  {
    path: '/system/role/authUser',
    name: 'AuthUser',
    component: 'AuthUser',
    meta: { title: '分配用户', noCache: true },
    permissions: ['system:role:edit'],
    hidden: true
  },
  {
    path: '/system/notice/form',
    name: 'NoticeForm',
    component: 'NoticeForm',
    meta: { title: '公告编辑', noCache: true },
    permissions: ['system:notice:edit'],
    hidden: true
  },
  {
    path: '/gen/edit',
    name: 'GenEdit',
    component: 'GenEdit',
    meta: { title: '修改生成配置', noCache: true },
    permissions: ['tool:gen:edit'],
    hidden: true
  }
]

/**
 * 基础路由
 * @type { *[] }
 */
export const constantRouterMap = [
  {
    path: '/user',
    component: UserLayout,
    redirect: '/user/login',
    hidden: true,
    children: [
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Login')
      },
      {
        path: 'register',
        name: 'register',
        component: () => import(/* webpackChunkName: "user" */ '@/views/user/Register')
      }
    ]
  },
  {
    path: '/404',
    component: () => import(/* webpackChunkName: "fail" */ '@/views/exception/404')
  }
]
